import { useCallback } from "react";

import AiChatPanel from "components/ai_chat/AiChatPanel";
import { AiDocumentSource } from "components/ai_chat/types";
import { useCitationNavigator } from "lib/core_components/useCitationNavigator";
import { AiContextProvider } from "lib/providers/AiContextProvider";

type DocumentAiSearchProps = {
  documentId: string;
  documentName: string;
};

export default function DocumentAiSearch({ documentId, documentName }: DocumentAiSearchProps) {
  const navigateToCitation = useCitationNavigator();

  const handleDocumentSourceClick = useCallback(
    (source: AiDocumentSource) => {
      // This tab is scoped to the open document, so citations always point at the
      // currently-loaded PDF. drawSourceAnnotations clears previous highlights first.
      navigateToCitation(source.locations ?? []);
    },
    [navigateToCitation],
  );

  return (
    <AiContextProvider
      context={{
        resourceId: documentId,
        resourceName: documentName,
        resourceType: "DOCUMENT_SINGLE_QA",
      }}
    >
      <AiChatPanel
        uiText={{
          title: "Ask Stotles AI about this document",
          subtitle:
            "I'll answer using only the content of this document. Ask for summaries, deadlines, requirements, or anything else it covers.",
          inputPlaceholder: "Ask a question about this document",
        }}
        showHistory
        historyPlacement="inline"
        onDocumentSourceClick={handleDocumentSourceClick}
        mainContainerPadding="16px"
        inlineHistoryContainerPadding="8px 0 0 0"
      />
    </AiContextProvider>
  );
}
